// extracted by mini-css-extract-plugin
module.exports = {"overlay":"afterpay-modal_overlay__pNvup","close":"afterpay-modal_close__odCCd","modalContainer":"afterpay-modal_modalContainer__lBXdY"};